var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgExpandMoreTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 6,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#858585",
  fillRule: "evenodd",
  d: "M.19 5.248A.75.75 0 0 1 .251 4.19l4.5-4a.75.75 0 0 1 .996 0l4.5 4a.75.75 0 0 1-.996 1.122L5.25 1.753 1.248 5.311A.75.75 0 0 1 .19 5.248",
  clipRule: "evenodd"
})));
export default SvgSvgExpandMoreTag;